import { api } from "@/api"

const { setToken } = useAuth()
const { setUser } = useCurrentUser()

export const logInBasic = async (params: {
  tenantIdentifier: string
  email: string
  password: string
}) => {
  const {
    body: { accessToken, user },
  } = await api.post<{
    accessToken: string
    user: UserAuthResponse
  }>("/auth/user-login/", {
    body: {
      email: params.email,
      password: params.password,
      merchantId: params.tenantIdentifier,
    },
    authenticated: false,
  })

  setUser(user)
  setToken(accessToken)
  return { accessToken, user }
}
